import { gql } from '@apollo/client';

export const CREATE_COMPANY_CONTACT_MUTATION = gql`
  mutation createCompanyContact(
    $companyId: Int!
    $firstName: String
    $localFirstName: String
    $middleName: String
    $localMiddleName: String
    $lastName: String!
    $localLastName: String
    $salutation: String
    $suffix: String
    $title: String
    $assistantName: String
    $assistantPhone: String
    $workEmail: String
    $personalEmail: String
    $directWorkPhone: String
    $mobilePhone: String
    $homePhone: String
    $otherPhone: String
    $fax: String
    $emailOptOut: Boolean
    $doNotCall: Boolean
    $receiveQuote: Boolean
    $receiveInvoice: Boolean
    $receiveArtifactsAsLinks: Boolean
    $receiveFinalReportPdf: Boolean
    $receiveAbbreviatedReportPdf: Boolean
    $mailingAddressLine1: String
    $mailingAddressLine2: String
    $mailingPoZipCode: String
    $otherAddressLine1: String
    $otherAddressLine2: String
    $otherCity: String
    $otherPoZipCode: String
    $notes: String
    $preferredLanguageId: Int
    $userId: Int
    $businessUnitId: Int
    $mailingCountryId: Int
    $otherCountryId: Int
    $departmentId: Int
    $mailingStateProvinceId: Int
    $otherStateProvinceId: Int
    $reportContactIds: [Int!]
    $resultIds: [Int!]
  ) {
    createCompanyContact(
      companyId: $companyId
      firstName: $firstName
      localFirstName: $localFirstName
      middleName: $middleName
      localMiddleName: $localMiddleName
      lastName: $lastName
      localLastName: $localLastName
      salutation: $salutation
      suffix: $suffix
      title: $title
      assistantName: $assistantName
      assistantPhone: $assistantPhone
      workEmail: $workEmail
      personalEmail: $personalEmail
      directWorkPhone: $directWorkPhone
      mobilePhone: $mobilePhone
      homePhone: $homePhone
      otherPhone: $otherPhone
      fax: $fax
      emailOptOut: $emailOptOut
      doNotCall: $doNotCall
      receiveQuote: $receiveQuote
      receiveInvoice: $receiveInvoice
      receiveArtifactsAsLinks: $receiveArtifactsAsLinks
      receiveFinalReportPdf: $receiveFinalReportPdf
      receiveAbbreviatedReportPdf: $receiveAbbreviatedReportPdf
      mailingAddressLine1: $mailingAddressLine1
      mailingAddressLine2: $mailingAddressLine2
      mailingPoZipCode: $mailingPoZipCode
      otherAddressLine1: $otherAddressLine1
      otherAddressLine2: $otherAddressLine2
      otherCity: $otherCity
      otherPoZipCode: $otherPoZipCode
      notes: $notes
      preferredLanguageId: $preferredLanguageId
      userId: $userId
      businessUnitId: $businessUnitId
      mailingCountryId: $mailingCountryId
      otherCountryId: $otherCountryId
      departmentId: $departmentId
      mailingStateProvinceId: $mailingStateProvinceId
      otherStateProvinceId: $otherStateProvinceId
      reportContactIds: $reportContactIds
      resultIds: $resultIds
    ) {
      companyContact {
        id
        companyId
        currentVersion {
          id
        }
      }
    }
  }
`;

export const ADD_COMPANY_CONTACT_VERSION_MUTATION = gql`
  mutation addVersionToCompanyContact(
    $companyContactId: Int!
    $firstName: String
    $localFirstName: String
    $middleName: String
    $localMiddleName: String
    $lastName: String!
    $localLastName: String
    $salutation: String
    $suffix: String
    $title: String
    $assistantName: String
    $assistantPhone: String
    $workEmail: String
    $personalEmail: String
    $directWorkPhone: String
    $mobilePhone: String
    $homePhone: String
    $otherPhone: String
    $fax: String
    $emailOptOut: Boolean
    $doNotCall: Boolean
    $receiveQuote: Boolean
    $receiveInvoice: Boolean
    $receiveArtifactsAsLinks: Boolean
    $receiveFinalReportPdf: Boolean
    $receiveAbbreviatedReportPdf: Boolean
    $mailingAddressLine1: String
    $mailingAddressLine2: String
    $mailingPoZipCode: String
    $otherAddressLine1: String
    $otherAddressLine2: String
    $otherCity: String
    $otherPoZipCode: String
    $notes: String
    $preferredLanguageId: Int
    $userId: Int
    $businessUnitId: Int
    $mailingCountryId: Int
    $otherCountryId: Int
    $departmentId: Int
    $mailingStateProvinceId: Int
    $otherStateProvinceId: Int
    $reportContactIds: [Int!]
    $resultIds: [Int!]
    $publish: Boolean
  ) {
    addVersionToCompanyContact(
      companyContactId: $companyContactId
      firstName: $firstName
      localFirstName: $localFirstName
      middleName: $middleName
      localMiddleName: $localMiddleName
      lastName: $lastName
      localLastName: $localLastName
      salutation: $salutation
      suffix: $suffix
      title: $title
      assistantName: $assistantName
      assistantPhone: $assistantPhone
      workEmail: $workEmail
      personalEmail: $personalEmail
      directWorkPhone: $directWorkPhone
      mobilePhone: $mobilePhone
      homePhone: $homePhone
      otherPhone: $otherPhone
      fax: $fax
      emailOptOut: $emailOptOut
      doNotCall: $doNotCall
      receiveQuote: $receiveQuote
      receiveInvoice: $receiveInvoice
      receiveArtifactsAsLinks: $receiveArtifactsAsLinks
      receiveFinalReportPdf: $receiveFinalReportPdf
      receiveAbbreviatedReportPdf: $receiveAbbreviatedReportPdf
      mailingAddressLine1: $mailingAddressLine1
      mailingAddressLine2: $mailingAddressLine2
      mailingPoZipCode: $mailingPoZipCode
      otherAddressLine1: $otherAddressLine1
      otherAddressLine2: $otherAddressLine2
      otherCity: $otherCity
      otherPoZipCode: $otherPoZipCode
      notes: $notes
      preferredLanguageId: $preferredLanguageId
      userId: $userId
      businessUnitId: $businessUnitId
      mailingCountryId: $mailingCountryId
      otherCountryId: $otherCountryId
      departmentId: $departmentId
      mailingStateProvinceId: $mailingStateProvinceId
      otherStateProvinceId: $otherStateProvinceId
      reportContactIds: $reportContactIds
      resultIds: $resultIds
      publish: $publish
    ) {
      companyContactVersion {
        id
      }
    }
  }
`;

export const SET_JOB_CONTACT = gql`
  mutation setJobContact(
    $contactIds: [Int!]!
    $jobId: Int!
    $serviceType: ExternalStakeholderServiceTypeEnum!
  ) {
    setJobContact(
      contactIds: $contactIds
      jobId: $jobId
      serviceType: $serviceType
    ) {
      success
    }
  }
`;

export const EDIT_COMPANY_CONTACT_VERSION_MUTATION = gql`
  mutation editDraftCompanyContactVersion(
    $companyContactId: Int!
    $firstName: String!
    $localFirstName: String
    $middleName: String
    $localMiddleName: String
    $lastName: String!
    $localLastName: String
    $salutation: String
    $suffix: String
    $title: String
    $assistantName: String
    $assistantPhone: String
    $workEmail: String
    $personalEmail: String
    $directWorkPhone: String
    $mobilePhone: String
    $homePhone: String
    $otherPhone: String
    $fax: String
    $emailOptOut: Boolean
    $doNotCall: Boolean
    $receiveQuote: Boolean
    $receiveInvoice: Boolean
    $receiveArtifactsAsLinks: Boolean
    $receiveFinalReportPdf: Boolean
    $receiveAbbreviatedReportPdf: Boolean
    $mailingAddressLine1: String
    $mailingAddressLine2: String
    $mailingPoZipCode: String
    $otherAddressLine1: String
    $otherAddressLine2: String
    $otherCity: String
    $otherPoZipCode: String
    $notes: String
    $preferredLanguageId: Int
    $userId: Int
    $businessUnitId: Int
    $mailingCountryId: Int
    $otherCountryId: Int
    $departmentId: Int
    $mailingStateProvinceId: Int
    $otherStateProvinceId: Int
    $reportContactIds: [Int!]
    $resultIds: [Int!]
    $publish: Boolean
  ) {
    editDraftCompanyContactVersion(
      companyContactId: $companyContactId
      firstName: $firstName
      localFirstName: $localFirstName
      middleName: $middleName
      localMiddleName: $localMiddleName
      lastName: $lastName
      localLastName: $localLastName
      salutation: $salutation
      suffix: $suffix
      title: $title
      assistantName: $assistantName
      assistantPhone: $assistantPhone
      workEmail: $workEmail
      personalEmail: $personalEmail
      directWorkPhone: $directWorkPhone
      mobilePhone: $mobilePhone
      homePhone: $homePhone
      otherPhone: $otherPhone
      fax: $fax
      emailOptOut: $emailOptOut
      doNotCall: $doNotCall
      receiveQuote: $receiveQuote
      receiveInvoice: $receiveInvoice
      receiveArtifactsAsLinks: $receiveArtifactsAsLinks
      receiveFinalReportPdf: $receiveFinalReportPdf
      receiveAbbreviatedReportPdf: $receiveAbbreviatedReportPdf
      mailingAddressLine1: $mailingAddressLine1
      mailingAddressLine2: $mailingAddressLine2
      mailingPoZipCode: $mailingPoZipCode
      otherAddressLine1: $otherAddressLine1
      otherAddressLine2: $otherAddressLine2
      otherCity: $otherCity
      otherPoZipCode: $otherPoZipCode
      notes: $notes
      preferredLanguageId: $preferredLanguageId
      userId: $userId
      businessUnitId: $businessUnitId
      mailingCountryId: $mailingCountryId
      otherCountryId: $otherCountryId
      departmentId: $departmentId
      mailingStateProvinceId: $mailingStateProvinceId
      otherStateProvinceId: $otherStateProvinceId
      reportContactIds: $reportContactIds
      resultIds: $resultIds
      publish: $publish
    ) {
      companyContactVersion {
        id
      }
    }
  }
`;
